<div>
  <div class="details-container">
    <div class="historical-data-section">
      <div class="table-container">
        <h2 class="name-title">
          {{ name() && (name().charAt(0) | uppercase) + name().slice(1) }}
        </h2>
        <table
          mat-table
          [dataSource]="historicalData()"
          class="mat-elevation-z8"
        >
          <!-- Date Column -->
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef class="bold-header">
              {{ 'Date' | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              [app-weekend-highlight]="element.date"
            >
              {{ element.date | localizedDate }}
            </td>
          </ng-container>

          <!-- Value Column -->
          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef class="bold-header">
              {{ 'Value' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.value }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
